import { useRef, useCallback } from 'react'


let IDCounter = 0
let IDCounterBottom = 0

export default function useID(stickyBottom?: boolean) {
  const ID = useRef(0)

  const getID = useCallback(() => {
    if (stickyBottom && !ID.current) {
      ID.current = --IDCounterBottom // eslint-disable-line no-plusplus
    }
    if (!ID.current) {
      ID.current = ++IDCounter // eslint-disable-line no-plusplus
    }
    return ID.current
  }, [stickyBottom])

  const resetIDs = useCallback(() => {
    IDCounter = 0
    IDCounterBottom = 0
  }, [])

  return {
    getID,
    resetIDs,
    currentID: ID.current,
  }
}
